import { useLingui } from '@lingui/react/macro'

import { H2 } from '../../../../_components/H2'
import { PrimaryButton } from '../../../../_components/PrimaryButton'

import type { IReviewProps } from '../../../_types/review'

import LazyImage from '@/components/LazyImage'
import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'


import { cls } from 'tagged-classnames-free';
export const ReviewFeatures: React.FC<{
  features: IReviewProps['features']
}> = ({ features }) => {
  const { t } = useLingui()

  if (!features) return null
  return (
    <div className='mx-auto flex max-w-[1152px] flex-col gap-9 px-4 py-14 md:gap-20 md:pb-[140px] md:pt-[154px]'>
      {features.map((item) => {
        return (
          <div
            key={item.title}
            className={cls`flex flex-col items-center gap-8 md:gap-[158px] ${item.isLeft ? 'md:flex-row-reverse' : 'md:flex-row'}`}
          >
            <div className='flex-1'>
              <H2 className='text-start md:text-4xl'>{item.title}</H2>
              <RichTextElement
                as='p'
                html={item.desc}
                className='text-f-other-10 [&_a]:text-f-primary pt-3 text-sm md:text-base [&_a]:hover:underline'
              />
              <PrimaryButton
                href={'/ai-music-generator'}
                className='mt-3 text-sm md:mt-6 md:text-base'
              >
                {item.btnText || t`Try Tad AI for Free`}
              </PrimaryButton>
            </div>
            <LazyImage
              width={480}
              height={320}
              src={item.img}
              alt={item.title}
              className='rounded-lg'
            />
          </div>
        )
      })}
    </div>
  )
}
